import { ParsedBanTarget } from '../types/networkData';

/**
 * Parses a ban target string into a structured object.
 *
 * Formats:
 *   "target:all"                → network-wide ban
 *   "target:cluster:BCG"        → cluster-scoped ban
 *   "target:single:bcg.playcdu.co" → single-server ban
 */
export function parseBanTarget(target: string): ParsedBanTarget {
  if (target === 'target:all') {
    return { scope: 'all', value: null };
  }
  if (target.startsWith('target:cluster:')) {
    return { scope: 'cluster', value: target.replace('target:cluster:', '') };
  }
  if (target.startsWith('target:single:')) {
    return { scope: 'single', value: target.replace('target:single:', '') };
  }
  // Unknown format — treat as network-wide
  return { scope: 'all', value: null };
}

/**
 * Returns a human-readable label for a parsed ban target.
 */
export function banTargetLabel(target: ParsedBanTarget): string {
  switch (target.scope) {
    case 'all':
      return 'Network-wide';
    case 'cluster':
      return target.value ?? 'Unknown Cluster';
    case 'single':
      return target.value ?? 'Unknown Server';
  }
}
